import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import Heading from '@atlaskit/heading';
import LegacyManualTriggerIcon from '@atlaskit/legacy-custom-icons/manual-trigger-icon';
import { ModalHeader, useModal } from '@atlaskit/modal-dialog';
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import { G50 } from '@atlaskit/theme/colors';
import { useAutomationMenu } from '../../menu-context';
var i18n = defineMessages({
  modalHeaderIconLabel: {
    id: 'automation-menu.modal.header.icon.label',
    defaultMessage: 'Automation modal header icon',
    description: 'A label for the icon in the header of the automation modal.'
  }
});
var iconStyle = xcss({
  marginRight: 'space.150',
  backgroundColor: 'color.background.accent.green.subtlest',
  borderRadius: 'border.radius'
});
var modalDescriptionStyle = xcss({
  marginTop: 'space.150'
});
export var AutomationModalHeaderOld = function AutomationModalHeaderOld(_ref) {
  var modalTitle = _ref.modalTitle,
    modalDescription = _ref.modalDescription;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAutomationMenu = useAutomationMenu(),
    initialised = _useAutomationMenu.initialised,
    rules = _useAutomationMenu.rules;
  var _useModal = useModal(),
    titleId = _useModal.titleId;
  var showDescription = initialised && rules.length > 0 && !!modalDescription;
  return /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: iconStyle,
    paddingInline: "space.050",
    paddingBlock: "space.025"
  }, /*#__PURE__*/React.createElement(LegacyManualTriggerIcon, {
    size: "small",
    label: formatMessage(i18n.modalHeaderIconLabel),
    primaryColor: "var(--ds-icon-accent-green, ".concat(G50, ")")
  })), /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    id: titleId
  }, modalTitle)), showDescription && /*#__PURE__*/React.createElement(Box, {
    xcss: modalDescriptionStyle
  }, modalDescription)));
};